import { AppState } from '@store/reducers';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '@env/environment';
import { svgIconList } from '@shared/svg-icon-list';
import { IsLoggedIn } from '@core/entity/auth/state/auth.selectors';
import { GameProviderHttpService } from '@core/services/game-provider-http.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
@Component({
  selector: 'app-game-menu',
  imports: [CommonModule, SafeHtmlPipe, TranslateModule],
  templateUrl: './game-menu.component.html',
  styleUrls: ['./game-menu.component.scss']
})
export class GameMenuComponent implements OnInit {

  @Input()
  fixed: string;

  @Input()
  gameCategoriesList: any;

  @Input()
  gameCategoryCode: string;

  @Input()
  gameCategoryName: string;

  @Output()
  demoEmitter = new EventEmitter<boolean>();

  navPath = '/assets/images/navigation-tab/';

  activeProviderTab: string;

  tabCount = 0;

  isSlotsPage$: any;
  isDemo$: any;

  showPokerTab = false;
  countryCode: any;
  isLoggedIn$: Observable<boolean>;
  providerslist: any[] = [];
  isSkeletonProvidersList = true;
  // tabs = [
  //   {code: 'LC', link: 'casino', name: 'Casino'},
  //   {code: 'SL', link: 'slots', name: 'Slots'},
  //   {code: 'FS', link: 'fishing', name: 'Fishing'},
  //   {code: 'SP', link: 'sports', name: 'Sports'},
  //   {code: 'ES', link: 'esports', name: 'Esports'}
  // ];

  minTabWidth = 0;
  activeTabIndex = 0;

  availableProvider: any;
  svg: any = svgIconList;

  environment = environment;
  projectCode = environment.projectCode.toLocaleLowerCase();

  // hardCodeCricketPositionProject = ['qp6', 'qp10', 'qp11', 'qp12'];

  isBrowser: boolean;

  constructor(
    private store: Store<AppState>,
    private eventEmitterService: EventEmitterService,
    private gameProviderHttpService: GameProviderHttpService,
    public dialog: MatDialog,
    private el: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.countryCode = localStorage.getItem('country_code');
      this.availableProvider = JSON.parse(localStorage.getItem('available_providers'));
    }
    this.isSlotsPage$ = this.gameProviderHttpService.isSlotsPage$;
    this.isDemo$ = this.gameProviderHttpService.isDemo$;
    this.isLoggedIn$ = this.store.pipe(select(IsLoggedIn));
    this.activeProviderTab = this.gameCategoryCode ? this.gameCategoryName : null;
    this.eventEmitterService.topBarTabVar = this.eventEmitterService.topBarTabEmitter.subscribe(() => {
      this.tabCount = 0;
      if (this.isBrowser) {
        this.availableProvider = JSON.parse(localStorage.getItem('available_providers'));
        this.countryCode = localStorage.getItem('country_code');
      }
      this.providerslist = [];
      if (this.availableProvider !== undefined) {
        Object.keys(this.gameCategoriesList).forEach((key) => {
          this.providerslist.push(key);
          if ( typeof this.availableProvider[key] !== "undefined" && this.availableProvider[key].length > 0) {
            this.tabCount++;
          }
        });
        this.setTab();
      }
    });

    console.log("this.gameCategoriesList : ", this.gameCategoriesList);
    console.log("this.availableProvider : ", this.availableProvider);
    if (this.availableProvider !== undefined) {
      this.providerslist = [];
      Object.keys(this.gameCategoriesList).forEach((key) => {
        this.providerslist.push(key);
        if (this.availableProvider[key]?.length > 0) {
          this.tabCount++;
        }
      });
      
      this.isSkeletonProvidersList = false;
      this.setTab();
    }

    // Temporary Hardcode Position For these projects
    // if (this.hardCodeCricketPositionProject.includes(this.projectCode)) {
    //   if (this.providerslist.length > 0 && this.availableProvider && this.availableProvider['CR'] && this.availableProvider['CR'].length > 0) {
    //     this.providerslist.sort((a, b) => {
        
    //       if (a == 'CR' && b != 'CR') {
    //         return -1;
    //       }
        
    //       if (a != 'CR' && b == 'CR') {
    //         return 1;
    //       }
        
    //       return 0;
    //     });
  
    //     const gameCategory = {
    //       code: 'CR',
    //       name: 'crickets'
    //     };
    
    //     this.eventEmitterService.onSelectProviderTabEmitter(gameCategory);
    //   }
    // }
  }

  onSelectCategoryTab(gameCategoryCode: string, gameCategoryName: string) {
    this.activeProviderTab = gameCategoryName;
    
    const gameCategory = {
      code: gameCategoryCode,
      name: gameCategoryName
    };

    this.eventEmitterService.onSelectProviderTabEmitter(gameCategory);

    if (gameCategoryCode === 'SL') {
      this.gameProviderHttpService.isSlotsPage$.next(true);
    } else {
      this.gameProviderHttpService.isSlotsPage$.next(false);
    }
    this.gameProviderHttpService.toggleSlotsDemoStorage(gameCategoryCode);
  }

  isBelongFromRoute(slug: string) {
    if (this.isBrowser && window.location.pathname.startsWith(`/${slug}`)) {
      return true;
    }
    return this.activeProviderTab === slug;
  }

  private setTab(){
    if (this.countryCode === 'ID'){
      // this.tabs.push({code: 'PK', link: 'poker', name: 'Poker'});
      // this.showPokerTab = true;
      this.minTabWidth = 100/this.tabCount;
    }else{
      this.showPokerTab = false;
      this.minTabWidth = 100/this.tabCount;
    }
  }

  private openDialogBy(componentRef: any, onSwitch: boolean) {
    this.dialog.open(componentRef, {
      data: {
        onSwitch: onSwitch
      }
    });
  }

}
